import React from 'react';

/**
 * Badge premium para pacientes cargados manualmente (alta rápida / n8n)
 * que aún no están vinculados a Plex/Geclisa.
 */
export default function PacienteExternoBadge({ show, compact = false }) {
  if (!show) return null;
  return (
    <span
      title="Paciente cargado manualmente (alta rápida). Aún no está vinculado a Plex/Geclisa."
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 4,
        padding: compact ? '2px 8px' : '3px 10px',
        borderRadius: 999,
        fontSize: compact ? 9 : 10,
        fontWeight: 800,
        letterSpacing: '.05em',
        textTransform: 'uppercase',
        background: 'linear-gradient(135deg,#7c3aed,#a855f7 55%,#c084fc)',
        color: '#fff',
        border: '1px solid rgba(124,58,237,.55)',
        boxShadow: '0 2px 6px rgba(124,58,237,.35), inset 0 1px 0 rgba(255,255,255,.35)',
        flexShrink: 0,
        lineHeight: 1.2,
        whiteSpace: 'nowrap'
      }}
    >
      <span style={{ fontSize: compact ? 9 : 10 }} aria-hidden="true">✦</span>
      Alta manual
    </span>
  );
}
